module.exports = __webpack_public_path__ + "static/img/applyReg.709d2d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applyReg.jpg
// module id = rAY2
// module chunks = 1